import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#EA001B", d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFA200", fillOpacity: 0.8, d: "M17 14a7 7 0 1 0 0-14 7 7 0 0 0 0 14" }));
const ForwardRef = forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
